// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const goodra: PokeData = {
  "id": 706,
  "name": "goodra",
  "height": 20,
  "weight": 1505,
  "base_experience": 270,
  "types": [
    PokeType.DRAGON
  ],
  "api_moves": [
    "tackle",
    "body-slam",
    "water-gun",
    "absorb",
    "bide",
    "bubble",
    "curse",
    "flail",
    "protect",
    "outrage",
    "dragon-breath",
    "rain-dance",
    "muddy-water",
    "poison-tail",
    "water-pulse",
    "feint",
    "aqua-tail",
    "dragon-pulse",
    "power-whip",
    "acid-spray",
    "tearful-look"
  ],
  "moves": [
    "tackle",
    "body-slam",
    "bubble",
    "curse",
    "protect",
    "outrage",
    "dragon-breath",
    "rain-dance",
    "aqua-tail",
    "dragon-pulse",
    "power-whip",
    "dragon-vortex",
    "dragon-rush"
  ],
  "evolution_chain": {
    "id": 362,
    "item": null,
    "species": [
      {
        "name": "goomy",
        "order": 704,
        "types": [
          PokeType.DRAGON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "sliggoo",
        "order": 705,
        "types": [
          PokeType.DRAGON
        ],
        "evolves_from_species_id": 704,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 40,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "goodra",
        "order": 706,
        "types": [
          PokeType.DRAGON
        ],
        "evolves_from_species_id": 705,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 50,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 138,
    "speed": 110,
    "ability_power": 152
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
